// extracted by mini-css-extract-plugin
module.exports = {"root":"LoaderDots_root__EZkcC","dot":"LoaderDots_dot__6e7bC","blink":"LoaderDots_blink__osfDq","isDark":"LoaderDots_isDark__9_Y2V"};